import React from 'react';
import ReactDOM from 'react-dom/client';

// CSS de librerías externas primero
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

// JS de Bootstrap (importación diferida o condicional)
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Proveedores e Integraciones
import { GoogleOAuthProvider } from '@react-oauth/google';
import { register as registerSwiper } from 'swiper/element/bundle';

import App from './App';

// Inicializar elementos personalizados de Swiper (Web Components)
registerSwiper();

// Extracción segura del Client ID desde variables de entorno
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "712134225346-4bmerv9fjnqqd7rsbcdsfhp3nkv4bjj6.apps.googleusercontent.com";

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  
  root.render(
    <React.StrictMode>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <App />
      </GoogleOAuthProvider>
    </React.StrictMode>
  );
}